export const DEFAULT_PAGINATION_LIMIT = 50
export const LIMIT_PAGINATION_VALUES = [5, 10, 15, 30, 50, 100]
